import { BasicCheckIn } from "~/common/utils/types/checkInTypes";
import { OrderCodes } from "../types/orderTypeValues";

export const getOrderByCode = (
  orderType: OrderCodes,
  checkInsList: BasicCheckIn[],
) => checkInsList.find((checkIn) => checkIn.code === orderType);
